<template>
  <div :key="componentKey">
    <!-- <form @submit.prevent="searchForm" @input.prevent="searchTimeOut">
      <v-btn color="primary" icon dark @click="openItem = true">
        <v-icon>mdi-plus</v-icon></v-btn
      >
      <v-text-field
        class="pb-5"
        v-model="search"
        chips
        clearable
        hide-details
        hide-selected
        prepend-icon="mdi-magnify"
        label="Search"
        solo
        @click:prepend="searchForm"
        @click:append="searchForm"
      />
    </form> -->

    <div v-on:mousemove="updateMouseCoordinates">
      <v-data-table
        :headers="headersComp"
        :items="items"
        :items-per-page="pagination.limit"
        class="elevation-1"
        disable-sort
        hide-default-footer
        @click:row="rowClick"
      >
      </v-data-table>

    </div>
    <div class="text-center">
      <!-- <v-pagination
        @input="changePage"
        v-model="pagination.page"
        :length="pagination.pages"
      ></v-pagination> -->

      <v-menu
        v-model="rowMenu.showMenu"
        :position-x="rowMenu.menuX"
        :position-y="rowMenu.menuY"
      >
        <v-list dense rounded>
          <v-list-item
            v-for="(action, index) in actions"
            :key="index"
            link
            @click="action.handle()"
          >
            <v-list-item-icon>
              <v-icon :color="action.color">{{ action.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-divider v-if="schemaActions && schemaActions.length"></v-divider> -->

        </v-list>
      </v-menu>
    </div>
    
      <CreateItensNotaFiscalView 
          :open="openItem"
          :itemEdit="itemSelected"
          :itemsByRomaneio="itemsByRomaneio"
          :jobSelected="jobSelected"
          :isNfRemessa="isNfRemessa"
          :isNfReferenciada="isNfReferenciada"
          @save="handleSaveItem"
          @cancel="openItem = false"
      />

  </div>
</template>

<script>
import Vue from 'vue'
import schemaService from "../../../services/schemaService";
import EntityService from "../../../services/entityService";

export default {
    name: 'TableNotaFiscal',
    //mixins: [entityPageMixin],
    props: ["schemaName", "ids", "relation", "item", 'itemsByRomaneio', 'jobSelected', 'isNfRemessa', 'isNfReferenciada'],
    components: {
        CreateItensNotaFiscalView: () => import('./CreateItensNotaFiscalView.vue')
    },
    data() {
        return {
            entityService: new EntityService('FisPreDocEmiItem'),
            openItem: false,
            schema: null,
            itemSelected: {},
            ncmFromJob: '',
            rowMenu: {
              showMenu: false,
              closeOnContentClick: false,
              x: 0,
              y: 0,
              menuX: 0,
              menuY: 0,
            },
            rowMenuOpen: false,
            pagination: {
              page: 1,
              limit: 30,
              pages: 1,
            },
            notVisibleTable: ['itemDescription', 'ordemDeServicoDescricao', 'jobItem', 'jobItemDescricao'],
            items: [],
            componentKey: 0,
            actions: [
                {
                    title: 'Visualizar/Editar',
                    icon: "mdi-pencil",
                    color: "warning",
                    handle: () => {
                      this.openItem = true;
                    }
                },
                {
                    title: 'Deletar',
                    icon: 'mdi-delete',
                    color: 'red',
                    handle: (type) => this.$emit('delete', type)
                }
            ],
        }
    },

    computed: {
      headersComp() {
        if (!this.schema) return [];

        let form = this.schema?.form?.properties;

        let properties = this.schema?.properties;
        let propertiesNames = Object.getOwnPropertyNames(properties || []);

        let maps = propertiesNames
          .filter((pn) => (properties[pn].relationSchema == null && !this.notVisibleTable.includes(pn)
          ) && form[pn])
          .map((p) => {
            let prop = form[p];
            return { text: prop.label, value: p, width: p == 'descricao' ? 500 : 100 };
          });

        if (this.schema.propertiesVisibleTable) {
          let propertiesVisibleTable = this.schema.propertiesVisibleTable?.split(',')
          maps.sort((a, b) => {

            let valueA = propertiesVisibleTable.indexOf(a.value);
            let valueB = propertiesVisibleTable.indexOf(b.value);

            if (valueA > valueB) return 1;
            else if (valueA < valueB) return -1;
            else return 0;


          });
        } else {
          maps.splice(maps.length - 1);
        }
        return maps;
      },
    },

    methods: {

      getItemKey(item) {
        if (item?.id != null) return `id_${item.id}`;
        return `seq_${item?.sequencia || ''}_desc_${item?.descricao || ''}`;
      },

      getProvidedItems() {
        if (!Array.isArray(this.item)) return [];

        return this.item.filter((entry) => entry && typeof entry === 'object' && !Array.isArray(entry));
      },

      formatCurrencyField(value) {
        return Number((Number(value) || 0) / 100).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) || 0;
      },

      normalizeIncomingItem(item) {
        if (!item || typeof item !== 'object') return item;

        const hasRawCurrencyValues = item.id != null && typeof item.valorUnitario === 'number';

        if (!hasRawCurrencyValues) {
          return { ...item };
        }

        return {
          ...item,
          valorBaseCalculoIbsCbs: this.formatCurrencyField(item.valorBaseCalculoIbsCbs),
          valorCbs: this.formatCurrencyField(item.valorCbs || 0),
          aliquotaCbs: item.aliquotaCbs || '',
          pisPercentual: item.pisPercentual,
          valorUnitario: this.formatCurrencyField(item.valorUnitario),
          valorTotal: this.formatCurrencyField(item.valorTotal),
          icmsValor: this.formatCurrencyField(item.icmsValor),
          pisValor: this.formatCurrencyField(item.pisValor),
          cofinsValor: this.formatCurrencyField(item.cofinsValor),
          ipiValor: this.formatCurrencyField(item.ipiValor),
          valorFrete: this.formatCurrencyField(item.valorFrete),
          valorSeguro: this.formatCurrencyField(item.valorSeguro),
          valorOutros: this.formatCurrencyField(item.valorOutros),
          valorDesconto: this.formatCurrencyField(item.valorDesconto)
        };
      },

      buildExistingItemsMap() {
        const existingItems = [
          ...(Array.isArray(this.items) ? this.items : []),
          ...this.getProvidedItems().map((entry) => this.normalizeIncomingItem(entry))
        ];

        return existingItems.reduce((map, entry) => {
          if (!entry) return map;
          map.set(this.getItemKey(entry), entry);
          return map;
        }, new Map());
      },

      mergeWithExistingItem(item, existingItemsMap) {
        const existingItem = existingItemsMap.get(this.getItemKey(item));

        if (!existingItem) return item;

        return {
          ...item,
          ...existingItem,
        };
      },

      timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      updateMouseCoordinates(event) {
        this.rowMenu.x = event.clientX;
        this.rowMenu.y = event.clientY;
      },

      async openRowMenu() {
        await this.timeout(100);
        this.rowMenu.menuX = this.rowMenu.x;
        this.rowMenu.menuY = this.rowMenu.y;

        this.$nextTick(() => {
          this.rowMenu.showMenu = true;
        });
      },

      async rowClick(row) {
        this.itemSelected = Object.assign({}, row);
        await this.openRowMenu();
      },
      
      async getSchema() {
        let res = await schemaService.getByName(this.schemaName);
        if (res?.data?.success) {
          this.schema = JSON.parse(res.data.data.jsonValue);
        }
      },
      async searchForm(){
          //this.searchItems()
      },

      parseMoeda(valor) {
          if (!valor) return 0;

          return parseFloat(
              valor.toLocaleString()
              ?.replace(/[^\d,.-]/g, '')
              ?.replace(/\./g, '')
              ?.replace(',', '.')
          ) || valor;
      },

      handleSaveItem(item){
        const itemUpdate = this.items.findIndex((i) => i.sequencia == item.sequencia)
        if (itemUpdate === -1) {
          this.items = [...this.items, item]
        } else {
          this.items.splice(itemUpdate, 1, item)
          this.items = [...this.items]
        }
        this.openItem = false;  
        this.componentKey += 1
        this.$emit('save-item', this.items)
        // Emite também para atualizar o totalComImpostos
        this.$emit('update-total-com-impostos', this.items)
      },

      getUniqueLatest(data) {
        const map = new Map();

        data.forEach(entry => {
          // pega a data mais relevante (se houver updateAt usa ele, senão createAt)
          const dateAtual = entry.updateAt ? new Date(entry.updateAt) : new Date(entry.createAt);

          if (!map.has(entry.item)) {
            map.set(entry.item, entry);
          } else {
            const existente = map.get(entry.item);
            const dateExistente = existente.updateAt ? new Date(existente.updateAt) : new Date(existente.createAt);

            // substitui pelo mais recente
            if (dateAtual > dateExistente) {
              map.set(entry.item, entry);
            }
          }
        });

        return Array.from(map.values());
      }

    },

    watch: {
      items(test){
        //console.log('TESTE AQUI ', test)
      },
      item: {
        handler(value) {
          const providedItems = Array.isArray(value)
            ? value.filter((entry) => entry && typeof entry === 'object' && !Array.isArray(entry))
            : [];

          if (!providedItems.length) return;

          const existingItemsMap = this.buildExistingItemsMap();

          this.items = providedItems
            .map((entry) => this.normalizeIncomingItem(entry))
            .map((entry) => this.mergeWithExistingItem(entry, existingItemsMap));
        },
        deep: true,
        immediate: true
      },
      async itemsByRomaneio(value) {
        console.log('itemsByRomaneio ', value);
        const existingItemsMap = this.buildExistingItemsMap();

        if (!Array.isArray(value) || value.length === 0) {
          const providedItems = this.getProvidedItems().map((entry) => this.normalizeIncomingItem(entry));

          if (providedItems.length > 0) {
            this.items = providedItems.map((entry) => this.mergeWithExistingItem(entry, existingItemsMap));
            this.$emit('save-item', this.items);
          }

          return;
        }

        // Usar um Map para garantir unicidade por id ou sequencia/descricao
        const uniqueMap = new Map();

        if (this.jobSelected.ncm) {
          await Vue.prototype.$http.get(`/Entity/NCM/${this.jobSelected.ncm}`).then((response) => {
            this.ncmFromJob = response.data.data.codigo;
          }).catch((error) => {
            console.error("Error fetching NCM:", error);
          });
          console.log('NCM from Job:', this.ncmFromJob);
        }

        for (let index = 0; index < value.length; index++) {
          const item = value[index];
          let newItem = null;

          if (item.id != undefined) {
            newItem = this.normalizeIncomingItem(item);
            // Chave única por id
            uniqueMap.set('id_' + item.id, this.mergeWithExistingItem(newItem, existingItemsMap));
            continue;
          }

          let itemUniqueLatestByItem;
          if (this.isNfRemessa) {
            const response = await Vue.prototype.$http.get('/Entity/StockBalance/search-fields', {
              params: {
                searchFields: 'itemDescricao',
                value: item.descricao,
                sortField: 'createAt'
              }
            });
            const itensResponse = response.data.data.data;
            const itemsUniqueLatest = this.getUniqueLatest(itensResponse);
            itemUniqueLatestByItem = itemsUniqueLatest.find((i) => i.itemDescricao == value[index].descricao);
          }

          let valorJob = Number(this.jobSelected.valorJob).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || 0;

          const valorUnitario = this.isNfRemessa
            ? Number(itemUniqueLatestByItem?.valorReal || 0)
            : Number((item?.precoUnitario ?? ((item?.precoUnitario) || 0))) || 0;

          const valorTotal = this.isNfRemessa
            ? Number(itemUniqueLatestByItem?.valorReal || 0)
            : Number((item?.precoTotal ?? ((item?.precoTotal) || 0))) || 0;

          newItem = {
            pedidodecompra: item.pedidoCompra || '',
            item: undefined,
            itemDescription: undefined,
            codigo: item?.codigo || undefined,
            jobItem: this.isNfRemessa ? undefined : item?._id || undefined,
            jobItemDescricao: this.isNfRemessa ? undefined : item?.descricao || undefined,
            itemPav: this.isNfRemessa ? item.itemCaldeiraria : undefined,
            ordemDeServico: item?.ordemServico?.id || item?.ordemServico?._id || undefined,
            ordemDeServicoDescricao: item?.ordemServico?.descricao || undefined,
            descricao: item?.descricao || undefined,
            operacaoFiscal: '',
            sequencia: item?.sequencia || index + 1,
            sequenciaPedidoDeCompra: item?.sequenciaPedidoDeCompra || '',
            pedidodevenda: '',
            itensPedidoDeVenda: '',
            ipiPercentualBaseCalculo: '',
            ipiBaseCalculo: 0,
            ipiPercentual: item.porcentagemIPI || '',
            ipiValor: item.valorIPI * 100 || 0,
            ipiAplicaSobreICMS: false,
            icmsPercentualBaseCalculo: '',
            icmsBaseCalculo: !this.isNfRemessa && !this.isNfReferenciada ? valorJob : '',
            icmsPercentual: item.porcentagemICMS || '',
            icmsValor: item.valorBaseICMS_ISS * 100 || 0,
            ctsPis: '01 - Operação Tributável com Alíquota Básica',
            ctsIpi: '00 - Tributada integralmente',
            ctsIcms: '00 - Tributada integralmente',
            ctsCofins: '01 - Operação Tributável com Alíquota Básica',
            quantidade: item.quantidade || 0,
            pisPercentualBaseCalculo: '',
            pisBaseCalculo: 0,
            pisPercentual: !this.isNfRemessa && !this.isNfReferenciada ? '1,65' : '',
            valorUnitario: valorUnitario.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) || 0,
            valorTotal: valorTotal.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) || 0,
            pisValor: item.valorPIS * 100 || 0,
            cofinsPercentualBaseCalculo: '',
            cofinsBaseCalculo: 0,
            cofinsPercentual: !this.isNfRemessa && !this.isNfReferenciada ? '7,60' : null,
            cofinsValor: item.valorCOFINS * 100 || 0,
            aliquotaCbs: '',
            valorCbs: 0,
            ncm: this.ncmFromJob || '',
            observacao: '',
            pesoBruto: '',
            pesoLiquido: '',
            cest: '',
            unidadeSigla: item?.unidadeSigla || '',
            valorBaseCalculoIbsCbs: 0
          };
          // Chave única para itens sem id: sequencia + descricao
          const uniqueKey = 'seq_' + (newItem.sequencia || '') + '_desc_' + (newItem.descricao || '');
          uniqueMap.set(uniqueKey, this.mergeWithExistingItem(newItem, existingItemsMap));
        }

        // Atualiza this.items com os valores únicos
        this.items = Array.from(uniqueMap.values());
        this.$emit('save-item', this.items);
      }
    },

    async mounted(){
      await this.getSchema()
    }
}
</script>